"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSavantClientFactory = void 0;
var managed_clients_1 = require("../managed-clients");
function isLegacyApiConfig(apiConfig) {
    var legacyApiConfig = apiConfig;
    return (legacyApiConfig.configKey !== undefined &&
        legacyApiConfig.version !== undefined);
}
function isEndpointTemplateApiConfig(apiConfig) {
    return (apiConfig.class
        .createFromEndpointTemplate !== undefined);
}
var getOverride = function (region, store, overide) {
    if (typeof overide === "string") {
        return overide;
    }
    else if (typeof overide === "object") {
        return overide[region];
    }
    else {
        return overide(store);
    }
};
exports.createSavantClientFactory = function (_a) {
    var fetch = _a.fetch, region = _a.region, secondLevelDomain = _a.secondLevelDomain, baseApiConfig = _a.baseApiConfig, store = _a.store, buildServiceEndpoint = _a.buildServiceEndpoint;
    return function (apiName, config) {
        if (config.overrideEndpoint) {
            var override = getOverride(region, store, config.overrideEndpoint);
            if (override) {
                console.warn(apiName + " is using overridden endpoint: " + override);
                return new config.class(fetch, override, baseApiConfig);
            }
        }
        if (isEndpointTemplateApiConfig(config)) {
            return config.class.createFromEndpointTemplate(fetch, region, secondLevelDomain, baseApiConfig);
        }
        if (!isLegacyApiConfig(config)) {
            throw new Error("Unable to construct " + apiName + ". Config is malformed.");
        }
        if (!buildServiceEndpoint) {
            throw new Error("Unable to construct " + apiName + ". Legacy config provided without buildServiceEndpoint");
        }
        var endpoint = buildServiceEndpoint(config.configKey, region, config.version, config.serviceEndpointFormat);
        return new config.class(fetch, endpoint, baseApiConfig);
    };
};
/**
 * Create managed clients using the clients created with savant-client-generator (or even duplo-api-client).
 *
 * The built in config options allow for overriding endpoints using a static string, a regional map, or a callback
 * function that takes the current store.
 *
 * @param config The savant client config map
 */
var createSavantClients = function (config) {
    return managed_clients_1.createRegionalManagedClients(config, function (_a) {
        var initialRegion = _a.initialRegion, rest = __rest(_a, ["initialRegion"]);
        return ({
            initialRegion: initialRegion,
            // using exports.* here so we can spy on them in unit tests
            createClients: function (region) {
                return exports.createSavantClientFactory(__assign({ region: region }, rest));
            },
        });
    });
};
exports.default = createSavantClients;
//# sourceMappingURL=createSavantClients.js.map